import React from 'react'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'

import { TextField, SelectMenuItem } from '../styles/TextField'
import { InputWrapperDiv } from '../styles/Containers'
import Label from './Label'

const getError = (id, errors) => {
  return id.split('.').reduce((o, i) => {
    const exists = o[i] !== undefined
    if (!exists) return {}
    return o[i]
  }, errors)
}

function FormSelect({
  children,
  required = false,
  id,
  label = '',
  options,
  defaultValue = '',
  disabled = false,
  tooltip = '',
  props,
  basis,
  minwidth,
  textFieldFormat = 'default'
}) {
  const { register, formState } = useFormContext()

  const errors = formState.errors
  const error = getError(id, errors)

  return (
    <InputWrapperDiv basis={basis} minwidth={minwidth}>
      <TextField
        {...register(id)}
        select
        id={id}
        name={id}
        label={label !== '' && <Label label={label} tooltip={tooltip} />}
        variant="standard"
        defaultValue={defaultValue}
        disabled={disabled}
        InputLabelProps={{
          shrink: true,
          required,
          focused: false
        }}
        InputProps={{
          disableUnderline: true
        }}
        haslabel={label === '' ? 'false' : 'true'}
        error={Object.keys(error).length > 0 && !!error}
        helperText={error?.message}
        FormHelperTextProps={{ role: 'alert' }}
        styleformat={textFieldFormat}
        {...props}>
        {children
          ? children
          : options.map(option => (
              <SelectMenuItem key={option} value={option}>
                {option}
              </SelectMenuItem>
            ))}
      </TextField>
    </InputWrapperDiv>
  )
}

FormSelect.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  required: PropTypes.bool,
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
  props: PropTypes.object,
  basis: PropTypes.string,
  minwidth: PropTypes.string,
  textFieldFormat: PropTypes.oneOf(['default', 'condensed'])
}

export default FormSelect
